module.exports = __webpack_public_path__ + "img/privilege9.d1bf8b3a.png";